import { useEffect } from 'react';

export default function useMisclick(onMisclick: (event: MouseEvent) => void, selector: string) {
    useEffect(
        function setupMisclick() {
            const handleDocumentClick = (event: MouseEvent) => {
                if (event.target) {
                    if (event.target instanceof Element) {
                        if (!event.target.closest(selector)) {
                            onMisclick(event);
                        }
                    } else {
                        onMisclick(event);
                    }
                }
            };

            document.addEventListener('click', handleDocumentClick);

            return () => document.removeEventListener('click', handleDocumentClick);
        },
        [onMisclick, selector]
    );
}
